export const enum ChatEndpoints {
  GET_HISTORY = '/chat/get-history',
  GET_MOST_ASKED_QUESTIONS = '/chat/most-asked',
  CREATE_CHAT = '/chat/create',
  SEND_MESSAGE = '/chat/sendMessage',
  REGENERATE_MESSAGE = '/chat/regenerateMessage',
  SEND_FEEDBACK = '/chat/sendFeedback'
}
